/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { useQuery } from 'react-query'

import { fetchAsJson } from '@modules/query/helpers'
import { getFeaturesUsageUrl, type GetFeaturesUsageUrlParams } from '@modules/cloud-api/v1/urls'
import type { FeaturesUsage } from '@modules/cloud-api/v1/types'
import type { QueryHookOptions } from '@modules/query/types'

import { defaultBillingOptions } from './constants'

const useGetFeaturesUsage = (params: GetFeaturesUsageUrlParams, options?: QueryHookOptions) =>
  useQuery(
    ['get-feature-usage', params.organizationId],
    () =>
      fetchAsJson<FeaturesUsage>(getFeaturesUsageUrl(params), {
        method: 'get',
      }),
    { ...defaultBillingOptions, ...options },
  )

export default useGetFeaturesUsage
